import angular from 'angular';

angular.module('cloudX').directive('validatePassword', [
  function() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attributes, ngModel) {
        ngModel.$validators.pwdLength = function(modelValue) {
          return modelValue.length >= 8; //Minimum 8 characters
        };

        ngModel.$validators.pwdCapital = function(modelValue) {
          return !!modelValue.match(/[A-Z]/); //Minimum 1 capital
        };
        ngModel.$validators.pwdNonCapital = function(modelValue) {
          return !!modelValue.match(/[a-z]/); //Minimum 1 non-capital
        };
        ngModel.$validators.pwdNumber = function(modelValue) {
          return !!modelValue.match(/\d/); //Minimum 1 number
        };
        ngModel.$validators.pwdSpecial = function(modelValue) {
          return !!modelValue.match(/[~\-!@@#\$%\^&\*\\.]/); //Minimum 1 special character
        };
      },
    };
  },
]);
